function relatedProducts() {
  return {
    loading: false,
    form: null,

    init() {
      const url = this.$el.dataset.url;
      const config = {
        method: "GET",
        headers: {
          "Content-Type": "text/html"
        }
      };

      fetch(url, config)
        .then((response) => response.text())
        .then((data) => {
          this.loading = false;
          const html = document.createElement("div");
          html.innerHTML = data;

          // Get the ID from the current element
          const sectionId = this.$el.id;
          const recommendations = html.querySelector(`#${sectionId}`);

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.$el.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    getSectionsToRender() {
      return [
        {
          id: "cart-icon-bubble",
          section: "cart-icon-section",
          selector: ".shopify-section"
        },

        {
          id: "cart-footer",
          section: "cart-footer",
          selector: ".live-contents"
        },
        {
          id: "cart-items",
          section: "cart-items",
          selector: ".live-contents"
        }
      ];
    }
  };
}

export default relatedProducts;
